import { useAppContext } from '../../appProvider/contextProvider';
import Loader from '../../components/Loader/loader';
import LogoContainer from '../../components/LogoContainer';
import PreLoginBanner from '../../components/PreloginBanner';


const ResetPassword = () => {

    const {isFetching, isMutating} = useAppContext();
    

    return <div className={!!(isMutating || isFetching) ? 'row no-gutters page-container loader full-height':  'row no-gutters full-height'}>
    {!!(isMutating || isFetching) && <Loader />}
        <div className="col col-12 col-lg-6">
            <div className="login-container d-flex flex-column justify-content-center full-height">                
                <LogoContainer />
                <h3 className="text-primary mb-2">Reset Your Password</h3>
                <p className="text-light mb-4">Send Notifications and Track your engagement!</p>
                <div className="form-group">
                    <label className="form-label">New Password <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-security"></i>
                        <input type="text" placeholder="Enter Your Password" className="form-control"/>
                        <button type="button" className="btn btn-neutral">
                        <i className="icon icon-password-mask"></i></button>
                    </div>
                </div>
                <div className="form-group">
                    <label className="form-label">Confirm New Password <span className="">*</span></label>
                    <div className="input-addon input-group-left">
                        <i className="icon icon-security"></i>
                        <input type="text" placeholder="Enter Your Password" className="form-control"/>
                        <button type="button" className="btn btn-neutral">
                        <i className="icon icon-password-mask"></i></button>
                    </div>
                </div>
                <button className="btn tbn-block btn-primary my-3">Reset Password</button>
                {/* <a className="text-center text-dark anchor-none" onClick={() => navigateTo('/login')}><i className="icon icon-chevron-left mr-2 "></i>Back to Login</a> */}
            </div>
        </div>
        <PreLoginBanner />
    </div>
}

export default ResetPassword;